import React, { useCallback, useEffect, useState } from 'react';
import { isDecisionDevBypass } from '../config/portalMode';
import { decisionSession, getDecisionToken, decisionLogout } from '../services/decisionApi';

const DEV_MOCK_USER = {
  id: 0,
  username: 'local-dev',
  portalRole: 'superadmin'
};

export function useDecisionAuth() {
  const [user, setUser] = useState(isDecisionDevBypass ? DEV_MOCK_USER : null);
  const [checking, setChecking] = useState(!isDecisionDevBypass);

  const refresh = useCallback(async () => {
    if (isDecisionDevBypass) {
      setUser(DEV_MOCK_USER);
      setChecking(false);
      return;
    }
    const token = getDecisionToken();
    if (!token) {
      setUser(null);
      setChecking(false);
      return;
    }
    try {
      const data = await decisionSession();
      if (data?.ok) setUser(data.user);
      else {
        setUser(null);
        decisionLogout();
      }
    } catch (e) {
      setUser(null);
      decisionLogout();
    } finally {
      setChecking(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = () => {
    if (isDecisionDevBypass) {
      setUser(DEV_MOCK_USER);
      return;
    }
    decisionLogout();
    setUser(null);
  };

  return { user, checking, refresh, logout, isLoggedIn: !!user };
}
